import * as React from 'react';
import { FC } from 'react';

const ToTop: FC = () => {

    const handleClick = async () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    };

    React.useEffect(() => {
        const handleScroll = () => {
            const toTopButton = document.getElementById('toTopButton');
            if (toTopButton) {
                if (window.scrollY > 300) {
                    toTopButton.classList.remove('hidden');
                    toTopButton.classList.remove('opacity-0');
                } else {
                    toTopButton.classList.add('hidden');
                    toTopButton.classList.add('opacity-1');
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <button
                type="button"
                onClick={handleClick}
                className='btn-primary bottom-8 right-8 fixed z-50 opacity-0 hidden transition-opacity duration-300'
                id="toTopButton"
            >
                <div className="icon-chevron-up" aria-hidden="true"></div>
                <span className='sr-only'>Hopp til toppen</span>
            </button>
        </>
    );
};
export default ToTop;
